import { BasePresenter } from "@presenters/base/base.presenter";
import { IFormBudgetDetails } from "@interfaces/screens/form-budget-details.interface";
import { useSelector } from 'react-redux';
import { Utilities, Dictionary } from "@utils";

export class FormBudgetDetailPresenter extends BasePresenter<IFormBudgetDetails> {

    private currentBudget: any;
    private currentLabel: Dictionary<string,string>;

    constructor(view: IFormBudgetDetails) {
        super(view);
        this.currentBudget = useSelector(this.context.budgetStore.selectCurrentBudget);
        this.currentLabel = useSelector(this.context.sessionStore.selectLabels);
    }

    public get budgetOnBudget(): any {
        if (Utilities.isNullEmptyObject(this.currentBudget))
            return "";

        return this.currentBudget.PPresTipoPresId === 2;
    }
    public get budgetYear(): any {
        if (Utilities.isNullEmptyObject(this.currentBudget) || Utilities.isNullEmptyObject(this.currentBudget.Year))
            return "";
        return Utilities.isEmptyObject(this.currentBudget.Year) ? "" : this.currentBudget.Year[0].label;
    }
    public get budgetRegionCountry(): any {
        if (Utilities.isNullEmptyObject(this.currentBudget) || Utilities.isNullEmptyObject(this.currentBudget.RegionCountry))
            return "";        
        return Utilities.isEmptyObject(this.currentBudget.RegionCountry) ? "" : this.currentBudget.RegionCountry[0].label;
    }
    public get budgetProjectTitle(): any {
        return this.currentBudget?.Title || "";
    }
    public get budgetProjectNumber(): any {
        return this.currentBudget?.PPresNumProy || "";
    }
    public get budgetProjectCode(): any {
        if (Utilities.isNullEmptyObject(this.currentBudget) || Utilities.isNullEmptyObject(this.currentBudget.PPresCodProy))
            return ""        
        return this.currentBudget.PPresCodProy        
    }
    public get budgetInterventionLine(): any {
        if (Utilities.isNullEmptyObject(this.currentBudget) || Utilities.isNullEmptyObject(this.currentBudget.LineaIntervencionId))
            return "";
        return Utilities.isEmptyObject(this.currentBudget.LineaIntervencionId) ? "" : this.currentBudget.LineaIntervencionId[0].label;
    }
    public get ffccTitle(): any {        
        if(Utilities.isNullEmptyObject(this.currentLabel))
            return "";
        return this.currentLabel.get("ffccTitle");
    }
    public get ffrrTitle(): any {        
        if(Utilities.isNullEmptyObject(this.currentLabel))
            return "";
        return this.currentLabel.get("ffrrTitle");
    }
    public get toolTipFfccTitle(): any {        
        if(Utilities.isNullEmptyObject(this.currentLabel))
            return "";
        return this.currentLabel.get("tooltipFfccTitle");
    }
    public get toolTipFfrrTitle(): any {        
        if(Utilities.isNullEmptyObject(this.currentLabel))
            return "";
        return this.currentLabel.get("tooltipFfrrTitle");
    }
    public get headerInformation(): any[]{
        return [
            {label: "Titulo de proyecto", value:this.budgetProjectTitle},
            {label: "Codigo proyecto", value:this.budgetProjectCode},
            {label: "Numero de proyecto", value:this.budgetProjectNumber},
            {label: "Anio", value:this.budgetYear},
            {label: "Pais/Region", value:this.budgetRegionCountry},
            {label: "Linea estrategica", value:this.budgetInterventionLine}                 
        ]
    }
}